import { render, staticRenderFns } from "./PointPriceGenerate.vue?vue&type=template&id=130a8668&scoped=true"
import script from "./PointPriceGenerate.vue?vue&type=script&lang=js"
export * from "./PointPriceGenerate.vue?vue&type=script&lang=js"
import style0 from "./PointPriceGenerate.vue?vue&type=style&index=0&id=130a8668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a8668",
  null
  
)

export default component.exports